import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { ScrollReveal } from '@/components/feature/PageLayout';

interface Testimonial {
  title: string;
  quote: string;
}

const testimonials: Testimonial[] = [
  {
    title: 'De ingeniero senior a gerente',
    quote: '"Me ayudó a ver claramente mi talento y me acompañó a potenciarlo, posicionando mi rol de líder dentro de la organización."',
  },
  {
    title: 'De recién egresada a supervisora',
    quote: '"Su acompañamiento fortaleció mi confianza cuando mi experiencia era mínima y hoy replico ese liderazgo con mi propio equipo."',
  },
  {
    title: 'De miedo a decisión',
    quote: '"Gracias al proceso de mentoría acepté retos fuera de mi zona de confort, expandí mis competencias y escalé de posiciones locales a regionales."',
  },
  {
    title: 'De inseguridad a liderazgo',
    quote: '"Su acompañamiento fue un pilar en mi primer rol gerencial fuera de mi ciudad, marcando mi estilo de liderazgo y acelerando mi crecimiento."',
  },
];

export default function CasosExitoPage() {
  return (
    <>
      <Navbar />
      <main className="bg-background-50">
        <section className="w-full pt-24 pb-8 md:pt-32 md:pb-12">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-[0.02em] text-foreground-950 leading-[1.05]">
              CASOS DE ÉXITO
            </h1>
          </div>
        </section>

        {/* Divider */}
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
          <div className="w-full h-px bg-background-300/60" />
        </div>

        {/* Divider + Testimonials */}
        <ScrollReveal>
          <section className="w-full py-12 md:py-16">
            <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
              <div className="border-t border-foreground-900/15 pt-10 md:pt-14">
                <div className="max-w-[900px]">
                  <div className="space-y-10 md:space-y-12">
                    {testimonials.map((t, i) => (
                      <div key={i}>
                        <h3 className="font-semibold text-foreground-950 text-base md:text-lg mb-3">
                          {t.title}
                        </h3>
                        <p className="text-foreground-700 text-base md:text-lg leading-relaxed italic">
                          {t.quote}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* CTA */}
        <ScrollReveal>
          <section className="pb-20 md:pb-28">
            <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
              <div className="border-t border-foreground-900/15 pt-10 md:pt-14">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 lg:gap-12">
                  <p className="text-foreground-950 text-base md:text-lg leading-relaxed max-w-[600px]">
                    Agenda una sesión sin costo para que juntos descubramos cómo puedes influir con mayor intención estratégica.
                  </p>
                  <Link
                    to="/agenda"
                    className="inline-block px-8 py-4 rounded-full text-sm font-medium tracking-[0.03em] whitespace-nowrap transition-all duration-300 cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 flex-shrink-0"
                  >
                    Agenda una sesión
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>
      </main>
      <Footer />
    </>
  );
}